// Generated by ReScript, PLEASE EDIT WITH CARE


var normaliseThrown = (function (thrown) {
    try {
      if (thrown instanceof Error) {
        return thrown;
      }

      if (thrown && typeof thrown === "object" && thrown.RE_EXN_ID) {
        if (thrown._1 instanceof Error) {
          return thrown._1;
        }

        var id = String(thrown.RE_EXN_ID).split("/")[0];

        var detail = "";
        if (typeof thrown._1 === "string") {
          detail = thrown._1;
        } else if (thrown._1 !== undefined) {
          try {
            detail = JSON.stringify(thrown._1);
          } catch (e) {
            detail = "[unserialisable]";
          }
        }

        var rebuilt = new Error(detail);
        rebuilt.name = id;

        if (thrown.Error && thrown.Error.stack) {
          rebuilt.stack = thrown.Error.stack;
        }
        return rebuilt;
      }
      return new Error("Non-Error thrown: " + String(thrown));
    } catch (e) {
      return new Error("Error normalisation failed");
    }
  });

var toReportableError = normaliseThrown;

var makeReportableError = (function (name, message) {
    var error = new Error(message);
    error.name = name;
    return error;
  });

export {
  normaliseThrown ,
  toReportableError ,
  makeReportableError ,
  
}
/* No side effect */
